import { Box, Skeleton, Tooltip, Typography, styled } from '@mui/material'
import { FC, ReactNode } from 'react'

import { theme } from '@/theme/theme'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type CardSummeryIconProps = {
  Icon: IconProp
  title: string | number
  subtitle?: string | number
  tooltip?: string | ReactNode
}

const CardSummeryIcon: FC<CardSummeryIconProps> = ({ Icon, title, subtitle, tooltip }) => {
  return (
    <Tooltip title={tooltip} disableHoverListener={!tooltip}>
      <StyledBox hover={!!tooltip}>
        <FontAwesomeIcon icon={Icon} fontSize={36} />
        <Typography marginTop={2} fontSize={18} fontWeight={theme.typography.fontWeightSemiBold}>
          {title}
        </Typography>
        <Typography fontSize={'0.875rem'}>{subtitle}</Typography>
      </StyledBox>
    </Tooltip>
  )
}

export const CardSummeryIconLoading: FC = () => (
  <StyledBox>
    <Skeleton width={48} height={48} variant="circular" />
    <Skeleton width={120} height={36} variant="rectangular" style={{ margin: '8px 0 ' }} />
    <Skeleton width={140} height={24} variant="rectangular" />
  </StyledBox>
)

const StyledBox = styled(Box)(({ hover }: { hover?: boolean }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  padding: theme.spacing(2),
  borderRadius: '8px',
  '&:hover': hover && {
    backgroundColor: theme.palette.cyan[50],
  },
}))

export default CardSummeryIcon
